import React, { useEffect, useState, useContext } from "react";
import "./WorkPolicyMaster.css";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  getWorkPolicyByIdUrl,
  InsertUpdateWorkPolicyData,
  CheckIfWorkPolicyExists,
  //Added by deepak
  PolicyHolidayDashboardData,
  GetPolicyHolidayDetailsByID,
  DeletePolicyHoliday,
  InsertUpdatePolicyHoliday,
  GetAllHolidaysByPolicyID,
  //added by kausher and yogesh
  exporttoExcelPolicyHoliday,
} from "../../../Helpers/API/APIEndPoints";
import InputForm from "../../../Components/InputForm/InputForm";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Heading from "../../../Components/Heading/Heading";
import moment from "moment";
import notify from "../../../Helpers/ToastNotification";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import HolidayDates from "../../../Components/HolidayDates/HolidayDates";
import { LoaderContext } from "../../../Helpers/Context/Context"; // added by mahesh
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
//import Modal from "@mui/material/Modal";
//kausher
import { Modal } from "react-bootstrap";
import { Box, TextField, Tooltip } from "@mui/material";
import { getContext } from "../../../Helpers/Context/Context";
import { truncate } from "node:fs";
import fileDownload from "js-file-download";
import axios from "axios";

const WorkPolicyMasterEdit = () => {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [workPolicyId, setWorkPolicyId] = useState(0);
  const [workPolicyName, setWorkPolicyName] = useState("");
  const [validFrom, setValidFrom] = React.useState<Date | null>(null);
  const [validTill, setValidTill] = React.useState<Date | null>(null);
  const [isActive, setIsActive] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [holidayDates, setHolidayDates] = useState([]);
  const [workingDaysList, setWorkingDaysList] = useState([]);
  const [workingSaturday, setWorkingSaturday] = useState([]);
  const { showLoader, hideLoader } = useContext(LoaderContext); //added by mahesh
  const [disabled, setDisabled] = useState(false);
  let formErrorObj = {};

  //kausher
  const [holidayName, setHolidayName] = useState(null);
  const [holidayDate, setHolidayDate] = React.useState<Date | null>(null);
  const [gridData, setGridData] = useState([]);
  const [deleteHolidayId, setDeleteHolidayId] = useState(0);
  const [holidayId, setHolidayId] = useState(0);
  const [isActiveHoliday, setIsActiveHoliday] = useState(true);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [editingId, setEditingId] = useState(null);
  //added by kausher
  const { EmployeeId } = getContext();
  //ADDED BY KAUSHER FOR SORTING AND SEARCHING
  const [pageSize, setPageSize] = useState(5);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  async function addHolidayValidation() {
    var objError = {};
    await setFormErrors({});

    if (!holidayName) {
      setFormErrors((preState) => ({
        ...preState,
        ["HolidayName_isEmpty"]: "Holiday Name can not be empty",
      }));
    }
    // kausher
    if (holidayDate == undefined || holidayDate == null) {
      setFormErrors((preState) => ({
        ...preState,
        ["holidayDate_isEmpty"]: "Holiday date can not be empty",
      }));
      //objError["holidayDate_isEmpty"] = "Holiday date can not be empty";
    }
  }
  //added by kausher and amogh
  const handleEditHoliday = (tempId, id) => {
    // Find the holiday based on tempId or id
    const holidayToEdit = gridData.find((holiday) => {
      // Use tempId if it's valid and non-zero, otherwise fallback to id
      return tempId && tempId !== 0
        ? holiday.tempId === tempId
        : holiday.id === id;
    });
    if (holidayToEdit) {
      // Populate the input fields with the holiday's data
      setHolidayName(holidayToEdit.holidayName);
      setHolidayDate(new Date(holidayToEdit.holidayDate));
      // Update the editingId correctly
      setEditingId(holidayToEdit.tempId || holidayToEdit.id);
      // Log to verify the state update
      // console.log('Editing holiday with ID:', holidayToEdit.tempId || holidayToEdit.id);
    } else {
      console.error("Holiday not found for editing");
    }
  };
  //handle add holiday
  const handleAddHoliday = () => {
    if (!holidayName || !holidayDate || !workPolicyName) {
      //notify(1, "Please enter Holiday Name, Holiday Date and Work Policy Name");
      addHolidayValidation();
      return;
    }
    // Add the new holiday to the gridData state
    const newHoliday = {
      id: 0,
      tempId: Math.floor(Math.random() * 99) + 1,
      workPolicyId: workPolicyId > 0 ? workPolicyId : 0,
      policyName: workPolicyName,
      holidayName,
      holidayDate: moment(holidayDate).format("YYYY-MM-DD"), // Format date as needed
      isActive: isActiveHoliday,
    };
    setGridData((prevData) => [...prevData, newHoliday]); // Update gridData state
    // Clear input fields after adding
    setHolidayName("");
    setHolidayDate(null);
    notify(0, "Holiday added successfully!");
  };
  //added by kausher and amogh
  const handleAddOrEditHoliday = () => {
    if (!holidayName || !holidayDate) {
      addHolidayValidation(); // Validate required fields
      return;
    }
    // Check if editing an existing holiday
    if (editingId) {
      const updatedData = gridData.map((holiday) => {
        if ((holiday.id > 0 ? holiday.id : holiday.tempId) === editingId) {
          return {
            ...holiday,
            holidayName,
            holidayDate: moment(holidayDate).format("YYYY-MM-DD"), // Format date
          };
        }
        return holiday;
      });
      setGridData(updatedData); // Update gridData with the edited holiday
      notify(0, "Holiday updated successfully!");
    } else {
      // Adding a new holiday
      const newHoliday = {
        id: 0,
        tempId: Math.floor(Math.random() * 99) + 1,
        holidayName,
        policyName: workPolicyName,
        holidayDate: moment(holidayDate).format("YYYY-MM-DD"),
      };
      setGridData((prevData) => [...prevData, newHoliday]); // Add the new holiday
      notify(0, "Holiday added successfully!");
    }
    // Clear input fields after adding/editing
    setHolidayName("");
    setHolidayDate(null);
    setEditingId(null); // Reset editing state
  };
  const handleOpenDeleteModal = (tempId, id) => {
    setDeleteHolidayId(tempId); // Set the tempId of the holiday to be deleted
    setHolidayId(id);
    setOpen(true); // Open the modal
  };
  const removeHoliday = async () => {
    // Handle local deletion
    if (deleteHolidayId > 0) {
      setGridData((prevData) =>
        prevData.filter(
          (holiday) => !(holiday.tempId === deleteHolidayId && holiday.id === 0)
        )
      );
      // Notify success and close modal
      handleClose();
      notify(0, "Holiday deleted locally!");
    } else {
      // Handle database deletion
      try {
        // Make an API call to delete the holiday from the database
        // console.log(holidayId);
        const requestObject = {
          id: holidayId,
        };
        const resp = await APICall(DeletePolicyHoliday, "POST", requestObject); // Replace with your API call
        if (resp.status == 0) {
          // Update grid data after successful deletion
          setGridData((prevData) =>
            prevData.filter((holiday) => holiday.id !== holidayId)
          );
          // Notify success and close modal
          handleClose();
          notify(0, "Holiday deleted successfully!");
        } else {
          throw new Error(resp.message || "Unknown error occurred.");
        }
      } catch (error) {
        // Handle errors if the API call fails
        console.error("Failed to delete holiday:", error);
        notify(1, "Failed to delete holiday. Please try again.");
      }
    }
  };
  // useState(()=>{
  //   setGridData(arr)
  // }, [arr]);
  //for grid colums options
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };
  const dynamicGridOptions = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortOrder(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortOrder(sortDirection);
      }
    },
    onChangePage: async (page) => {
      const newStart = page * pageSize;
      setStart(newStart);
    },
  };
  const gridColumns = [
    {
      name: "tempId",
      label: "tempId",
      options: {
        display: false,
      },
    },
    {
      name: "workPolicyId",
      label: "Work Policy Id",
      options: {
        display: false,
      },
    },
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "policyName",
      label: "Policy Name",
      options: {
        display: false,
      },
    },
    {
      name: "holidayName",
      label: "Holiday Name",
      options: {
        display: true,
        sort: true,
      },
    },
    {
      name: "holidayDate",
      label: "Holiday Date",
      options: {
        display: true,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const tempId = gridData[tableMeta.rowIndex]?.tempId; // Extract tempId from row data
          const id = gridData[tableMeta.rowIndex]?.id;
          return (
            <>
              <a
                onClick={() => handleEditHoliday(tempId, id)} // Pass tempId for editing
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i>
              </a>
              <a
                style={{ marginLeft: "20px", cursor: "pointer" }}
                onClick={() => handleOpenDeleteModal(tempId, id)} // Pass tempId for deleting
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
            </>
          );
        },
      },
    },
  ];

  //get the data from the selected workpolicy by Id
  const getWorkpolicyById = async () => {
    if (state !== null) {
      let post = {
        id: state,
      };

      let postHoliday = {
        id: state,
        pageSize: pageSize,
        start: start,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        searchText: searchText,
      };

      const { data } = await APICall(getWorkPolicyByIdUrl, "POST", post);

      if (data !== null || typeof data !== "string") {
        setWorkPolicyId(data.id);
        setWorkPolicyName(data.policyName);
        setIsActive(data.isActive);
        setValidFrom(data.validFrom);
        setValidTill(data.validTill);

        const holidayData = await APICall(
          GetAllHolidaysByPolicyID,
          "POST",
          postHoliday
        );
        const totalCount =
          holidayData.data.length > 0 ? holidayData.data[0].totalCount : 0;
        // Set the count state
        setCount(totalCount);
        //added by kausher and amogh
        const formattedData = holidayData.data.map((item) => ({
          ...item,
          holidayDate: formatDateToYYYYMMDD(item.holidayDate),
        }));
        setGridData(formattedData);
        // setGridData(holidayData.data);
        // console.log(gridData);

        let arr = [];
        let arr2 = [];

        if (data.working_Saturday !== null) {
          let s = data.working_Saturday.split(",");
          let x = [];
          s.map((i) => {
            x.push(workingSaturdayOptions[i]);
          });

          setWorkingSaturday(x);
        }

        if (data.holiday1 !== null) {
          arr.push(moment(data.holiday1).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday2 !== null) {
          arr.push(moment(data.holiday2).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday3 !== null) {
          arr.push(moment(data.holiday3).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday4 !== null) {
          arr.push(moment(data.holiday4).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday5 !== null) {
          arr.push(moment(data.holiday5).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday6 !== null) {
          arr.push(moment(data.holiday6).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday7 !== null) {
          arr.push(moment(data.holiday7).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday8 !== null) {
          arr.push(moment(data.holiday8).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday9 !== null) {
          arr.push(moment(data.holiday9).format(moment.HTML5_FMT.DATE));
        }

        if (data.holiday10 !== null) {
          arr.push(moment(data.holiday10).format(moment.HTML5_FMT.DATE));
        }
        if (data.holiday11 !== null) {
          arr.push(moment(data.holiday11).format(moment.HTML5_FMT.DATE));
        }

        if (data.workingDay1 !== null) {
          arr2.push({ value: data.workingDay1, label: data.workingDay1 });
        }

        if (data.workingDay2 !== null) {
          arr2.push({ value: data.workingDay2, label: data.workingDay2 });
        }

        if (data.workingDay3 !== null) {
          arr2.push({ value: data.workingDay3, label: data.workingDay3 });
        }

        if (data.workingDay4 !== null) {
          arr2.push({ value: data.workingDay4, label: data.workingDay4 });
        }

        if (data.workingDay5 !== null) {
          arr2.push({ value: data.workingDay5, label: data.workingDay5 });
        }

        if (data.workingDay6 !== null) {
          arr2.push({ value: data.workingDay6, label: data.workingDay6 });
        }

        setHolidayDates(arr);
        setWorkingDaysList(arr2);
      }
    }
  };

  //added by kausher and amogh
  // Helper function to format date to DD-MM-YYYY
  function formatDateToYYYYMMDD(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  const options = [
    { value: "Monday", label: "Monday", id: 1 },
    { value: "Tuesday", label: "Tuesday", id: 2 },
    { value: "Wednesday", label: "Wednesday", id: 3 },
    { value: "Thursday", label: "Thursday", id: 4 },
    { value: "Friday", label: "Friday", id: 5 },
    { value: "Saturday", label: "Saturday", id: 6 },
    { value: "Sunday", label: "Sunday", id: 7 },
  ];

  const workingSaturdayOptions = [
    { value: 0, label: "First Saturday" },
    { value: 1, label: "Second Saturday" },
    { value: 2, label: "Third Saturday" },
    { value: 3, label: "Fourth Saturday" },
    { value: 4, label: "Fifth Saturday" },
  ];

  useEffect(() => {
    getWorkpolicyById();
  }, []);

  useEffect(() => {});
  //added by kausher
  useEffect(() => {
    getWorkpolicyById();
  }, [start, sortColumn, sortOrder, searchText]);

  const getDataOnSubmit = async (requestObject: any) => {
    if (requestObject !== null) {
      const res = await APICall(
        InsertUpdateWorkPolicyData,
        "POST",
        requestObject
      );

      gridData.map((data) => {
        const holidayRequestObject = {
          id: data.id,
          policyId: res.data,
          holidayName: data.holidayName,
          holidayDate: data.holidayDate,
          isActive: data.isActive,
          createdBy: Number(EmployeeId),
          modifiedBy: Number(EmployeeId),
        };
        if (holidayRequestObject !== null) {
          const res = APICall(
            InsertUpdatePolicyHoliday,
            "POST",
            holidayRequestObject
          );
        }
      });

      if (res.status === 1) {
        notify(res.status, res.message);
      } else {
        navigate(-1);
      }
    }
  };

  const ConvertArrayToString = (arr) => {
    let s = [];
    if (arr[0] === undefined) {
      return "";
    }
    arr.map((i) => s.push(i.value));
    return s.join(",");
  };

  const onClickFunction = async (action) => {
    let sortedHolidayList = holidayDates.sort();
    let workingSaturdayString = ConvertArrayToString(workingSaturday);
    if (action === "submit") {
      setDisabled(true);
      showLoader(); //added by mahesh
      let requestObject = {
        id: workPolicyId,
        policyName: workPolicyName,
        validFrom: moment(validFrom).format(moment.HTML5_FMT.DATE),
        validTill: moment(validTill).format(moment.HTML5_FMT.DATE),
        HolidayDates: sortedHolidayList,
        WorkingDates: workingDaysList,
        isActive: isActive,
        Working_Saturday: workingSaturdayString,
        createdBy: Number(EmployeeId),
        modifiedBy: Number(EmployeeId),
      };

      //submitApiCall
      if (workPolicyId !== 0) {
        requestObject.id = workPolicyId;
      }

      let ero = await submitValidation();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );

      if (isEmpty === true) {
        setDisabled(false);
        await getDataOnSubmit(requestObject);
      } else {
        setDisabled(false);
      }
      hideLoader(); //added by mahesh
    }

    if (action === "reset") {
      setFormErrors({});
      setWorkPolicyName("");
      setValidFrom(null);
      setValidTill(null);
      setHolidayDates([]);
      setWorkingDaysList([]);
      setGridData([]);

    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "validFrom") {
      setValidFrom(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["validFrom_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["validFrom_isEmpty"]: "Valid From date can not be empty",
        }));
      }
    }
    if (apiFieldName === "validTill") {
      setValidTill(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["validTill_isEmpty"]: undefined,
          ["Invalid Date"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["validTill_isEmpty"]: "Valid From date can not be empty",
        }));
      }
    }
    // added by kausher
    if (apiFieldName === "holidayDate") {
      setHolidayDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["holidayDate_isEmpty"]: undefined,
          ["Invalid Date"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["holidayDate_isEmpty"]: "holidayDate date can not be empty",
        }));
      }
    }

    if (apiFieldName === "workingSaturday") {
      setWorkingSaturday(event);
    }

    if (apiFieldName === "workPolicyName") {
      if (event.target.value.length < 10) {
        setWorkPolicyName(event.target.value);
      }

      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["workPolicyName_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["workPolicyName_isEmpty"]: "Valid From date can not be empty",
        }));
      }
    }

    if (apiFieldName === "workingDaylist") {
      setWorkingDaysList(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["workingDaysList_isEmpty"]: undefined,
          ["workingDaysList_5"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["workingDaysList_5"]: "Working Day cannot be less than 5",
        }));
      }
    }
  };
  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "workPolicyName") {
      setWorkPolicyName(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["workPolicyName_isEmpty"]: undefined,
        }));
        formErrorObj["workPolicyName_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["workPolicyName_isEmpty"]: "Work policy name cannot be empty",
        }));
        formErrorObj["workPolicyName_isEmpty"] =
          "Work policy name cannot be empty";
      }
    } else if (apiFieldName === "holidayName") {
      setHolidayName(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["HolidayName_isEmpty"]: undefined,
        }));
        formErrorObj["HolidayName_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["HolidayName_isEmpty"]: "holiday name cannot be empty",
        }));
        formErrorObj["HolidayName_isEmpty"] = "holiday name cannot be empty";
      }
    }
  };

  const submitValidation = async () => {
    var objError = {};

    await setFormErrors({});

    if (!workPolicyName) {
      setFormErrors((preState) => ({
        ...preState,
        ["workPolicyName_isEmpty"]: "Work Policy Name can not be empty",
      }));
    }

    const data = await APICall(CheckIfWorkPolicyExists, "POST", {
      policyName: workPolicyName,
    });
    if (data.data != undefined || data.data != null) {
      if (data.data === true && state == null) {
        objError["WorkPolicy_exists"] = "WorkPolicy already exists";
      }
    }
    if (
      workPolicyName == undefined ||
      workPolicyName == null ||
      workPolicyName == ""
    ) {
      objError["workPolicyName_isEmpty"] = "Work Policy Name can not be empty";
    }

    if (validFrom == undefined || validFrom == null) {
      objError["validFrom_isEmpty"] = "Valid From date can not be empty";
    }

    if (validTill == undefined || validTill == null) {
      objError["validTill_isEmpty"] = "Valid Till date can not be empty";
    }

    if (workingDaysList.length < 5) {
      objError["workingDaysList_5"] = "Working Day cannot be less than 5";
    }

    // if (holidayDates.length < 9) {
    //   objError["LeastHolidays"] = "9 Holidays are mandatory!";
    // }

    if (
      workingDaysList.filter((e) => e.value === "Saturday").length > 0 &&
      workingSaturday.length < 0
    ) {
      objError["workingSaturday"] = "Select Working Saturday";
    }

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  // added by kausher, yogesh
  const ExportToExcel = async () => {
    axios
      .request({
        responseType: "blob",
        method: "POST",
        //data: Response,
        url: exporttoExcelPolicyHoliday,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: {
          id: state,
          searchText: searchText,
          sortColumn: sortColumn,
          sortDirection: sortOrder,
        },
      })
      .then((response) => {
        fileDownload(response.data, "WorkPolicyHoliday Report.xlsx");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  return (
    <div>
      <Heading title={"Work Policy Master"} />
      <div className="container-fluid">
        <div className="row">
          {/* Work Policy Name */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Work Policy Name <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={workPolicyName}
                onChange={(e) => setWorkPolicyName(e.target.value)}
              />
              <p style={{ color: "red" }}>
                {formErrors["WorkPolicy_exists"]}
                {formErrors["workPolicyName_isEmpty"]}
              </p>
            </div>
          </div>

          {/* Valid From */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Valid From <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="valid From"
                  value={validFrom}
                  onChange={(e) => selectOnChange(e, "validFrom")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>{formErrors["validFrom_isEmpty"]}</p>
            </div>
          </div>

          {/* Valid Till */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Valid Till <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="valid Till"
                  value={validTill}
                  onChange={(e) => selectOnChange(e, "validTill")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>{formErrors["validTill_isEmpty"]}</p>
            </div>
          </div>

          {/* Working Days */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Working days <sup>*</sup>
              </label>
              <SelectForm
                value={workingDaysList}
                onChange={(e) => selectOnChange(e, "workingDaylist")}
                options={options}
                isMulti
                isSearchable={false}
                isClearable={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                placeholder="Select Working Days"
              />
              <p style={{ color: "red" }}>{formErrors["workingDaysList_5"]}</p>
            </div>
          </div>

          {/* Working Saturdays */}
          {workingDaysList.filter((e) => e.value === "Saturday").length > 0 && (
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="form-group">
                <label>
                  Working Saturdays <sup>*</sup>
                </label>
                <SelectForm
                  value={workingSaturday}
                  onChange={(e) => selectOnChange(e, "workingSaturday")}
                  options={workingSaturdayOptions}
                  isMulti
                  isSearchable={false}
                  isClearable={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Select Working Saturday"
                />
                <p style={{ color: "red" }}>{formErrors["workingSaturday"]}</p>
              </div>
            </div>
          )}

          {/* Is Active */}
          {state && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="isActive">Is Active</label>
                <div>
                  <input
                    type="checkbox"
                    id="isActive"
                    onChange={(e) => setIsActive(e.target.checked)}
                    name="isActive"
                    checked={isActive}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Holiday Name & Date */}

          <div className="row align-items-end">
            <div className="col-lg-2 col-md-2 col-sm-4">
              <div className="form-group">
                <label>Holiday Name</label>
                <InputForm
                  style={{ height: 37 }}
                  placeholder={"Holiday Name"}
                  isDisabled={false}
                  textArea={false}
                  value={holidayName}
                  onChange={(e) => handleTextEvent(e, "holidayName")}
                />
                <div style={{ position: "relative" }}>
                  <p
                    style={{
                      color: "red"
                    }}
                  >
                    {formErrors["HolidayName_exists"]}
                    {formErrors["HolidayName_isEmpty"]}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-4">
              <div className="form-group">
                <label className="d-block">Holiday Date</label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Holiday Date"
                    value={holidayDate}
                    onChange={(e) => selectOnChange(e, "holidayDate")}
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField size="small" required {...params} />
                    )}
                  />
                </LocalizationProvider>
                <div style={{ position: "relative" }}>
                  <p
                    style={{
                      color: "red"
                    }}
                  >
                    {formErrors["holidayDate_isEmpty"]}
                  </p>
                </div>
              </div>
            </div>

            {/* Save / Add Holiday Button */}
            <div
              className="col-lg-2 col-md-2 col-sm-6"
              style={{
                paddingLeft: "0",
                marginTop: "15px",
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <div className="form-group" style={{ width: "100%" }}>
                {editingId ? (
                  <button
                    style={{ height: "37px", width: "100%" }}
                    className="btn btn-submit"
                    onClick={handleAddOrEditHoliday}
                  >
                    Save Changes
                  </button>
                ) : (
                  <button
                    className="btn btn-submit"
                    onClick={handleAddOrEditHoliday}
                  >
                    Add Holiday
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* added by kausher, yogesh */}
          {/* Export to Excel */}
          <div className="px-3 mb-2 pt-3 d-flex justify-content-end">
            <button onClick={() => ExportToExcel()} className="btn btn-export">
              Export to Excel
            </button>
          </div>

          {/* Delete Holiday Modal */}
          <Modal
            show={open}
            onHide={handleClose}
            backdrop="static"
            centered
            size="sm"
          >
            <Modal.Body className="text-center delete_body p-4">
              <i className="fa fa-info mb-3"></i>
              <p className="mb-3">
                Are you sure, you want to delete this holiday?
              </p>
              <div className="d-flex justify-content-center gap-2">
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="btn btn-reset"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-delete"
                  onClick={removeHoliday}
                >
                  Yes
                </button>
              </div>
            </Modal.Body>
          </Modal>

          {/* Dynamic Grid */}
          <div>
            <DynamicGrid
              options={dynamicGridOptions}
              data={gridData.length > 0 ? gridData : []}
              columns={gridColumns}
            />
          </div>

          {/* Reset & Submit Buttons */}
          <div className="col-lg-12 mt-3">
            <div className="d-flex justify-content-between">
              <button onClick={() => navigate(-1)} className="btn btn-reset">
                <i className="fa fa-chevron-left"></i>
              </button>
              <div className="d-flex gap-2">
                <button
                  onClick={() => onClickFunction("reset")}
                  className="btn btn-reset"
                >
                  Reset
                </button>
                <button
                  onClick={() => onClickFunction("submit")}
                  className="btn btn-submit"
                  disabled={disabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkPolicyMasterEdit;